<div class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60 backdrop-blur-sm">
  <div class="bg-white rounded-2xl shadow-2xl w-full max-w-lg mx-4 overflow-hidden">
    
    <!-- Header - Temporary Lock -->
    <div *ngIf="lockType === 'temporary'" 
         class="bg-gradient-to-r from-orange-500 to-orange-600 px-6 py-5">
      <div class="flex items-center space-x-4">
        <div class="bg-white bg-opacity-20 rounded-full p-3">
          <i class="fas fa-lock text-white text-2xl"></i>
        </div>
        <div>
          <h3 class="text-white text-2xl font-bold">Cuenta Bloqueada Temporalmente</h3>
          <p class="text-orange-100 text-sm">Por seguridad, tu cuenta ha sido bloqueada</p>
        </div>
      </div>
    </div>

    <!-- Header - Permanent Lock -->
    <div *ngIf="lockType === 'permanent'" 
         class="bg-gradient-to-r from-red-600 to-red-700 px-6 py-5">
      <div class="flex items-center space-x-4">
        <div class="bg-white bg-opacity-20 rounded-full p-3">
          <i class="fas fa-ban text-white text-2xl"></i>
        </div>
        <div>
          <h3 class="text-white text-2xl font-bold">Cuenta Bloqueada</h3>
          <p class="text-red-100 text-sm">Se requiere intervención de un administrador</p>
        </div>
      </div>
    </div>

    <!-- Body -->
    <div class="px-6 py-8">
      
      <!-- Temporary Lock Content -->
      <div *ngIf="lockType === 'temporary'" class="space-y-6">
        
        <!-- Timer Display -->
        <div class="flex items-center justify-center">
          <div class="bg-gradient-to-br from-orange-50 to-orange-100 rounded-2xl px-8 py-6 border-2 border-orange-200 shadow-lg">
            <div class="text-center">
              <p class="text-sm text-gray-600 font-medium mb-2">Tiempo restante</p>
              <div class="flex items-center justify-center space-x-2">
                <i class="fas fa-hourglass-half text-orange-600 text-2xl"></i>
                <p class="text-5xl font-bold text-orange-600 font-mono">{{ displayTime }}</p>
              </div>
            </div>
          </div>
        </div>

        <!-- Reason -->
        <div class="bg-orange-50 border-l-4 border-orange-500 rounded-r-lg p-5">
          <div class="flex items-start space-x-3">
            <i class="fas fa-exclamation-triangle text-orange-600 text-xl mt-1"></i>
            <div>
              <p class="text-sm font-semibold text-gray-800 mb-2">¿Por qué fue bloqueada mi cuenta?</p>
              <p class="text-sm text-gray-700 leading-relaxed">
                Tu cuenta fue bloqueada por <strong>{{ getLockDuration() }}</strong> debido a múltiples intentos fallidos de inicio de sesión.
              </p>
            </div>
          </div>
        </div>

        <!-- Incident Warning -->
        <div class="bg-yellow-50 border-l-4 border-yellow-500 rounded-r-lg p-5">
          <div class="flex items-start space-x-3">
            <i class="fas fa-shield-alt text-yellow-600 text-xl mt-1"></i>
            <div>
              <p class="text-sm font-semibold text-gray-800 mb-2">Incidencia {{ incident }}/3</p>
              <p class="text-sm text-gray-700 leading-relaxed">
                {{ getIncidentMessage() }}
              </p>
            </div>
          </div>
        </div>

        <!-- Security Notice -->
        <div class="bg-blue-50 border-l-4 border-blue-500 rounded-r-lg p-5">
          <div class="flex items-start space-x-3">
            <i class="fas fa-info-circle text-blue-600 text-xl mt-1"></i>
            <div>
              <p class="text-sm font-semibold text-gray-800 mb-2">Si no fuiste tú</p>
              <p class="text-sm text-gray-700 leading-relaxed mb-3">
                Si no reconoces estos intentos de acceso, te recomendamos cambiar tu contraseña inmediatamente después de que se desbloquee tu cuenta.
              </p>
              <div class="flex flex-wrap gap-2">
                <button class="text-xs bg-blue-600 hover:bg-blue-700 text-white font-medium px-4 py-2 rounded-lg transition-colors duration-200 flex items-center space-x-2">
                  <i class="fas fa-key"></i>
                  <span>Recuperar Contraseña</span>
                </button>
                <button class="text-xs bg-gray-600 hover:bg-gray-700 text-white font-medium px-4 py-2 rounded-lg transition-colors duration-200 flex items-center space-x-2">
                  <i class="fas fa-headset"></i>
                  <span>Contactar Soporte</span>
                </button>
              </div>
            </div>
          </div>
        </div>

      </div>

      <!-- Permanent Lock Content -->
      <div *ngIf="lockType === 'permanent'" class="space-y-6">
        
        <!-- Icon -->
        <div class="flex justify-center">
          <div class="bg-red-100 rounded-full p-6">
            <i class="fas fa-user-lock text-red-600 text-5xl"></i>
          </div>
        </div>

        <!-- Message -->
        <div class="text-center space-y-3">
          <h4 class="text-xl font-bold text-gray-800">Tu cuenta ha sido bloqueada permanentemente</h4>
          <p class="text-gray-600 leading-relaxed">
            Por razones de seguridad, tu cuenta ha sido bloqueada después de múltiples intentos fallidos de inicio de sesión.
          </p>
        </div>

        <!-- Incident Info -->
        <div class="bg-red-50 border-l-4 border-red-500 rounded-r-lg p-5">
          <div class="flex items-start space-x-3">
            <i class="fas fa-exclamation-circle text-red-600 text-xl mt-1"></i>
            <div>
              <p class="text-sm font-semibold text-gray-800 mb-2">Incidencia {{ incident }}/3 - Límite alcanzado</p>
              <p class="text-sm text-gray-700 leading-relaxed">
                Has alcanzado el máximo de incidencias permitidas. Se requiere que un administrador desbloquee tu cuenta.
              </p>
            </div>
          </div>
        </div>

        <!-- Contact Support -->
        <div class="bg-blue-50 border-l-4 border-blue-500 rounded-r-lg p-5">
          <div class="flex items-start space-x-3">
            <i class="fas fa-headset text-blue-600 text-xl mt-1"></i>
            <div class="flex-1">
              <p class="text-sm font-semibold text-gray-800 mb-3">Contacta a un administrador</p>
              <div class="space-y-2 text-sm text-gray-700">
                <div class="flex items-center space-x-2">
                  <i class="fas fa-envelope text-gray-500 w-5"></i>
                  <span>soporte@creditotal.com</span>
                </div>
                <div class="flex items-center space-x-2">
                  <i class="fas fa-phone text-gray-500 w-5"></i>
                  <span>+58 XXX-XXXXXXX</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Action Buttons -->
        <div class="flex flex-col sm:flex-row gap-3">
          <button class="flex-1 bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-6 rounded-xl shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 transition-all duration-200 flex items-center justify-center space-x-2">
            <i class="fas fa-headset"></i>
            <span>Contactar Soporte</span>
          </button>
          <button 
            (click)="close()"
            class="flex-1 bg-gray-600 hover:bg-gray-700 text-white font-bold py-3 px-6 rounded-xl shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 transition-all duration-200 flex items-center justify-center space-x-2">
            <i class="fas fa-arrow-left"></i>
            <span>Volver</span>
          </button>
        </div>

      </div>

    </div>

    <!-- Footer -->
    <div class="bg-gray-50 px-6 py-4 border-t border-gray-200">
      <div class="flex items-center justify-center space-x-2 text-sm text-gray-600">
        <i class="fas fa-shield-alt"></i>
        <span>Esta medida protege tu cuenta contra accesos no autorizados</span>
      </div>
    </div>

  </div>
</div>
